(function ($) {
    $.fn.rightBurgerMenu = function () {
        var $self = $(this);
        var $button = $self.find('.js-right-burger-button');
        var $menuItem = $self.find('.js-link-scroll');
        var $body = $('.js-fc-body');


        var init = function () {
            $button.on('click', function () {
                toggleClass();
            });
            $menuItem.on('click', function () {
                $self.removeClass('open');
                $body.removeClass('fc-body-no-scroll');
            })
        };

        var toggleClass = function () {
            $self.toggleClass('open');
            $body.toggleClass('fc-body-no-scroll');
        };

        init();
    };

    $('.js-right-burger').each(function () {
        $(this).data('rightBurgerMenu', $(this).rightBurgerMenu());
    });
})(jQuery);
